export default "__VITE_ASSET__bb4f66d3__"